import { isUserInGroup } from "../../extractors";
import { useUser } from "../../hooks";
import { convertSpecificationKeyToLabel } from "../../utils";
import { DetailsItem } from "../Details";
import { PROJECT_ENGINEER_ROLE } from "./SpecificationConstants";

type OwnProps = {
  specifications?: $TSFixMe;
};

const defaultProps: Partial<OwnProps> = {
  specifications: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function SpecificationDetails({ specifications }: Props) {
  const user = useUser();

  const isUserProjectEngineer = isUserInGroup(user, PROJECT_ENGINEER_ROLE);

  return specifications
    ? Object.keys(specifications)
        .filter(
          (key) => isUserProjectEngineer || specifications[key].ui_visible,
        )
        .sort()
        .map((key) => (
          <DetailsItem
            id={key}
            key={key}
            label={convertSpecificationKeyToLabel(key)}
            value={specifications[key].value}
          />
        ))
    : null;
}

SpecificationDetails.defaultProps = defaultProps;

export default SpecificationDetails;
